import _mergeJSXProps from "babel-helper-vue-jsx-merge-props";
export default {
  name: 'More',
  functional: true,
  render: function (h, ctx) {
    return h(
      "svg",
      _mergeJSXProps([{
        attrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }
      }, ctx.data]),
      [h("line", {
        attrs: { fill: "none", stroke: "currentColor", "stroke-width": "4", "stroke-linecap": "round", "stroke-linejoin": "round", x1: "12", y1: "12", x2: "12", y2: "12" }
      }), h("line", {
        attrs: { fill: "none", stroke: "currentColor", "stroke-width": "4", "stroke-linecap": "round", "stroke-linejoin": "round", x1: "19", y1: "12", x2: "19", y2: "12" }
      }), h("line", {
        attrs: { fill: "none", stroke: "currentColor", "stroke-width": "4", "stroke-linecap": "round", "stroke-linejoin": "round", x1: "5", y1: "12", x2: "5", y2: "12" }
      })]
    );
  }
};